import React, { useCallback, useMemo } from 'react';

import { useAppDispatch } from '../../../hooks/react-redux';
import { Attestation, AttestationManager } from '../../shared/icons';
import { TileSelect, Tile } from '../../shared/tile-select/TileSelect';
import { CalculatorManagerPage, setCalculatorManagerPage } from './store';

export const CalculatorManagerSelect: React.FC = () => {
    const dispatch = useAppDispatch();
    const selectCalculatorManagerPage = useCallback((page: CalculatorManagerPage) => dispatch(setCalculatorManagerPage(page)), [dispatch]);
    const selectManager = useCallback(() => selectCalculatorManagerPage(CalculatorManagerPage.MANAGER), [selectCalculatorManagerPage]);
    const selectPrompts = useCallback(() => selectCalculatorManagerPage(CalculatorManagerPage.PROMPTS), [selectCalculatorManagerPage]);

    const calculatorTiles: Tile[] = useMemo(() => [
        {
            label: CalculatorManagerPage.MANAGER,
            description: ['Manage the calculator fields within Ark51', 'Configure the pad options available within a calculator field'],
            onClick: selectManager,
            testId: 'forms',
            icon: Attestation
        },
        {
            label: CalculatorManagerPage.PROMPTS,
            description: ['Manage and tweak multi-shot learning prompts for calculator fields', 'Help to improve AI accuracy extracting complicated calculations from documents'],
            onClick: selectPrompts,
            testId: 'manager',
            icon: AttestationManager
        },
    ], [selectManager, selectPrompts]);

    return (
        <TileSelect testId='admin-calculator' tiles={calculatorTiles} />
    );
};
